<h2 mat-dialog-title class="label-orange-color">Error</h2>
<mat-dialog-content>
	<div class="copo-simple-dialog-content">
		<div [ngSwitch]="errorStatus">
			<div translate>
				<ng-container *ngSwitchCase="'user_not_found'">
					<b><span class="label-orange-color" translate>login.user-not-found</span></b>
				</ng-container>
				<ng-container *ngSwitchCase="'bad_password'">
					<b><span class="label-orange-color">
							<p translate>login.bad-password</p>
							<p translate>login.password-attempts-exceeded</p>
					</span></b>
				</ng-container>
				<ng-container *ngSwitchCase="'password_attempt_blocked'">
					<b><span class="label-orange-color" translate>login.password-attempts-blocked </span></b> </ng-container>
				<ng-container *ngSwitchCase="'password_already_used'">
					<b><span class="label-orange-color" translate>confirm-password-legacy.password-already-used
						</span></b>
				</ng-container>
				<ng-container *ngSwitchCase="'password-not-respect-rules'">
					<b><span class="label-orange-color" translate>confirm-password-legacy.password-not-respect-rules
						</span></b>
				</ng-container>
				<ng-container *ngSwitchCase="'client_id_not_found'">
					<b><span class="label-orange-color" translate>login.client-id-not-found </span></b>
				</ng-container>
				<ng-container *ngSwitchCase="'unknown_redirect_uri'">
					<b><span class="label-orange-color" translate> login.unknown-redirect-uri </span></b>
				</ng-container>
				<ng-container *ngSwitchCase="'client_id_outdated'">
					<b><span class="label-orange-color" translate> login.client-id-outdated </span></b>
				</ng-container>
				<ng-container *ngSwitchCase="'client_id_disabled'">
					<b><span class="label-orange-color" translate> login.client-id-disabled </span></b>
				</ng-container>
				<ng-container *ngSwitchDefault><b><span class="label-orange-color">{{errorStatus}}</span></b></ng-container>
			</div>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions class="button-group">
	<button type="button" mat-button color="primary" class="copo-button-font" (click)="closeDialog()">
		<span >close</span>
	</button>
</mat-dialog-actions>
